import { styled } from '@linaria/react'
import { PageContent, PageLayout } from '@reapitform/dashboard-ui'
import { ITabsItem, Tabs } from '@reapitform/common-ui'
import React from 'react'
import { Link } from 'react-router-dom'
import { DocumentTabContent } from './view'
import { LinkTabContent } from './view/links'
import { SpecialConditionTabContent } from './view/special-conditions'
import { EmergencyContactTabContent } from './view/emergency-contacts'

export const Links = styled(Link)``

export const DefaultPage: React.FC = () => {
  const tabItems: ITabsItem[] = [
    {
      name: 'document',
      title: 'Documents',
      component: <DocumentTabContent />,
    },
    {
      name: 'link',
      title: 'Links',
      component: <LinkTabContent />,
    },
    {
      name: 'special-conditions',
      title: 'Special Conditions',
      component: <SpecialConditionTabContent />,
    },
    {
      name: 'repairer',
      title: 'Repairers',
      component: <EmergencyContactTabContent />,
    },
  ]

  return (
    <PageLayout pageTitle="Defaults">
      <PageContent>
        <Tabs tabItems={tabItems} />
      </PageContent>
    </PageLayout>
  )
}
